<div *ngIf="isWorkBook" id="stockholder-preview" style="width: 100%;
margin: 0px auto;font-family :Arial, sans-serif; padding: 10px 8px; position: relative; height: auto;
    min-height: 100%; display: flex; flex-direction: column;">
</div>
<div class="page A4" *ngIf="!isWorkBook" id="stockholder-preview"
    style="border-radius: 5px;
    border: 1px solid #D9D9D9;
    margin: 0px auto;
    padding-bottom: 0px;
    font-family :Arial, sans-serif;
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    height: auto !important;
  min-height: 100% !important;">
</div>

